import templateRoutes from 'components/Template/RoutesTemplate';
import ledgerMobileViewRoutes from 'containers/AccountLedgerModule/AccountLedgerMobileView/LedgerMobileViewRoutes';
import AccountLedgerSubmenuRoutes from 'containers/AccountLedgerModule/AccountLedgerSubmenuRoutes';
import AccountLedgerTransactionRoutes from 'containers/AccountLedgerModule/AccountLedgerTransactionRoutes';
import clientAcctRoutes from 'containers/AssociateAccountModule/ClientAccountRoutes';
import associateRoutes from 'containers/AssociateModule/AssociateRoutes';
import authenticationRoutes from 'containers/Authentication/AccountRoutes';
import calendarRoutes from 'containers/CalendarModule/CalendarRoutes';
import companyRoutes from 'containers/CompanyModule/CompanyRoutes';
import contractConsolidateEInvoiceRoutes from 'containers/ConsolidateEInvoiceModule/ConsolidateEInvoiceRoutes';
import contractRoutes from 'containers/ContractModule/ContractRoutes';
import subcontractRoutes from 'containers/ContractModule/SubcontractRoutes';
import eDocRoutes from 'containers/EDocModule/EDocRoutes';
import eLetteringRoutes from 'containers/ELettering/ELetteringRoutes';
import financialReportingRoutes from 'containers/FinancialReportingModule/FinancialReportingRoutes';
import fuelConsumptionRoutes from 'containers/FuelConsumptionModule/FuelConsumptionRoutes';
import generalSettingRoutes from 'containers/GeneralSettingModule/GeneralSettingRoutes';
import glInterfaceRoutes from 'containers/GLInterfaceModule/GLInterfaceRoutes';
import groupBIRoutes from 'containers/GroupBIModule/GroupBIModuleMenuRoutes';
import homeRoutes from 'containers/HomeModule/HomeRoutes';
import plantMachineryRoutes from 'containers/PlantMachineryModule/PlantMachineryRoutes';
import profitRecognitionRoutes from 'containers/ProfitRecognitionModule/ProfitRecognitionRoute';
import projectCostAdjustmentRoutes from 'containers/ProjectCostAdjustment/ProjectCostAdjustmentRoutes';
import projectCostingRoutes from 'containers/ProjectCostingModule/ProjectCostingRoutes';
import projectPurchaseRoutes from 'containers/ProjectPurchaseModule/ProjectPurchaseRoutes';
import POBprojectPurchaseRoutes from 'containers/POBProjectPurchaseModule/ProjectPurchaseRoutes';
import projectTenderRoutes from 'containers/ProjectTenderModule/ProjectTenderRoutes';
import SubconAccountRoutes from 'containers/SubconAccountModule/SubconAccountRoutes';
import subconTenderRoutes from 'containers/SubconTenderModule/SubconTenderRoutes';
import subcontractorRoutes from 'containers/SubcontractorModule/SubcontractorRoutes';
import supplierRoutes from 'containers/SupplierModule/SupplierRoutes';
import systemAdminRoutes from 'containers/SystemAdminModule/SystemAdminRoutes';
import workRoutes from 'containers/WorkDeskModule/WorkRoutes';
import { Redirect } from 'react-router-dom';
import React from 'react';

const redirectRoute = [
  {
    props: { exact: true, path: '/' },
    component: <Redirect to="/" />,
  },
];

const errorRoute = [{ component: <Redirect to="/authentication/404" /> }];

//error route always at the bottom//
const routes = [
  ...homeRoutes,
  ...companyRoutes,
  ...workRoutes,
  ...eDocRoutes,
  ...eLetteringRoutes,
  ...ledgerMobileViewRoutes,
  ...SubconAccountRoutes,
  ...AccountLedgerSubmenuRoutes,
  ...AccountLedgerTransactionRoutes,
  ...systemAdminRoutes,
  ...generalSettingRoutes,
  ...financialReportingRoutes,
  ...subcontractorRoutes, // old design
  ...supplierRoutes,
  ...contractRoutes,
  ...projectPurchaseRoutes,
  ...POBprojectPurchaseRoutes,
  ...projectTenderRoutes,
  ...subcontractRoutes,
  ...subconTenderRoutes,
  ...plantMachineryRoutes,
  ...fuelConsumptionRoutes,
  ...projectCostingRoutes,
  ...projectCostAdjustmentRoutes,
  ...glInterfaceRoutes,
  ...profitRecognitionRoutes,
  ...authenticationRoutes,
  ...associateRoutes,
  ...clientAcctRoutes,
  ...calendarRoutes,
  ...groupBIRoutes,
  ...contractConsolidateEInvoiceRoutes,
  ...templateRoutes,
  ...redirectRoute,
  ...errorRoute,
];

export default routes;
